/* eslint-disable react/prop-types */
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SaveIcon from "@mui/icons-material/Save";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import { useEffect, useMemo, useRef, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  AlertState,
  DataCountryState,
  DataNationState,
  DataProvinceState,
  DataStatusState,
  DataTypeOwnerState,
  SettingState,
} from "states";
import CustomFieldForm from "../../components/CustomFieldForm";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import {
  API_ROUTES,
  CODE_QUANGNAM,
  PaperComponent,
  validateArrayFileRequired,
} from "../../utils/constants";
import { JsonTool } from "../../utils/jsonTools";
import BusinessIcon from "@mui/icons-material/Business";
import ArticleIcon from "@mui/icons-material/Article";
import CustomTabPanel from "components/CustomPanel/customPanel";
import AddListFile from "components/AddListFile";

const optionGioiTinh = [
  {
    id: "M",
    ten: "Nam",
  },
  {
    id: "F",
    ten: "Nữ",
  },
  {
    id: "O",
    ten: "Khác",
  },
];

const defaultValue = {
  ma: "",
  ten: "",
  email: "",
  dienthoai: "",
  diachi: "",
  maphuong: null,
  maquan: null,
  matinh: CODE_QUANGNAM,
  loaihinh: null,
  ngaycap: null,
  coquancap: "",
  nguoidaidienphapluat: "",
  nguoidaidienphapluat_email: "",
  nguoidaidienphapluat_diachi: "",
  nguoidaidienphapluat_dienthoai: "",
  nguoidaidienphapluat_chucvu: "",
  gioitinh: null,
  quocgia: 1,
  ngaysinh: null,
  dantoc: 1,
  socccd: "",
  ngaycap_cccd: null,
  noicap_cccd: "",
  ghichu: "",
  solaodongquanly: 0,
  solaodongsanxuat: 0,
  trangthai: null,
  username: "",
};

const FormChuTheOCOP = ({
  data,
  open,
  onClose,
  onSubmit,
  title,
  validationErrors,
  action,
  dataDistrictQN,
  dataUser,
}) => {
  // state lỗi giá trị từ form
  const formRef = useRef(null);
  const axiosPrivateInstance = useAxiosPrivate();

  const [errors, setErrors] = useState();
  const [dataState, setDataState] = useState(defaultValue);
  const [value, setValue] = useState(0);

  const setAlert = useSetRecoilState(AlertState);
  const optionProvince = useRecoilValue(DataProvinceState);
  const optionDanToc = useRecoilValue(DataNationState);
  const optionQuocGia = useRecoilValue(DataCountryState);
  const optionLoaiHinh = useRecoilValue(DataTypeOwnerState);
  const optionTrangThai = useRecoilValue(DataStatusState);
  const [optionDistrict, setOptionDistrict] = useState([]);
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  const settingState = useRecoilValue(SettingState);

  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});

  const getSubditrict = (code) => {
    axiosPrivateInstance
      .get(API_ROUTES.GETXA, { params: { huyen: code } })
      .then((res) => {
        setOptionSubDitrict(res?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  const getDistrict = (code, disCode) => {
    axiosPrivateInstance
      .get(API_ROUTES.GETHUYEN, { params: { tinh: code } })
      .then((res) => {
        setOptionDistrict(res?.data);
        setOptionSubDitrict([]);
        if (disCode) {
          getSubditrict(disCode);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //change
  const handleChangeProvince = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        matinh: value,
        maquan: "",
        maphuong: "",
      };
    });
    getDistrict(value);
  };
  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
        maphuong: "",
      };
    });
    getSubditrict(value);
  };
  const fieldInfor = useMemo(() => {
    let result = [
      {
        name: "Mã/số đăng ký kinh doanh",
        key: "ma",
        required: true,
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Tên chủ thể",
        key: "ten",
        type: "text",
        required: true,
        maxLength: 1000,
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Tỉnh thành",
        key: "matinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        onChange: handleChangeProvince,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Quận/Huyện",
        key: "maquan",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        onChange: handleChangeDistrict,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Phường/Xã",
        key: "maphuong",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "ma",
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Địa chỉ",
        key: "diachi",
        type: "text",
        maxLength: 1000,
        xs: 12,
        md: 12,
        lg: 12,
      },
      {
        name: "Email",
        key: "email",
        type: "text",
        maxLength: 255,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số điện thoại",
        key: "dienthoai",
        type: "text",
        maxLength: 150,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Loại hình tổ chức",
        key: "loaihinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap",
        type: "date",
        required: true,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Cơ quan cấp",
        key: "coquancap",
        type: "text",
        maxLength: 225,
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Tài khoản người dùng",
        key: "username",
        type: "autocomplete",
        required: true,
        hasPlaceholder: true,
        unicode: "username",
        labelKeyOption: "username",
        xs: 12,
        md: 8,
        lg: 8,
      },
      {
        name: "Trạng thái",
        key: "trangthai",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số lao động quản lý",
        key: "solaodongquanly",
        type: "number",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Số lao động sản xuất",
        key: "solaodongsanxuat",
        type: "number",
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Ghi chú",
        key: "ghichu",
        type: "textArea",
        maxLength: 500,
        xs: 12,
        md: 12,
        lg: 12,
      },
    ];
    return result;
  }, []);

  const fieldNguoiDaiDien = useMemo(() => {
    let result = [
      {
        name: "Người đại diện pháp luật",
        key: "nguoidaidienphapluat",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Email người đại diện",
        key: "nguoidaidienphapluat_email",
        type: "text",
        maxLength: 50,
        xs: 12,
        md: 6,
        lg: 6,
      },
      {
        name: "Địa chỉ người đại diện",
        key: "nguoidaidienphapluat_diachi",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Số điện thoại người đại diện",
        key: "nguoidaidienphapluat_dienthoai",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Chức vụ",
        key: "nguoidaidienphapluat_chucvu",
        type: "text",
        maxLength: 200,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Giới tính",
        key: "gioitinh",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Quốc gia",
        key: "quocgia",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Dân tộc",
        key: "dantoc",
        type: "select",
        required: true,
        hasPlaceholder: true,
        unicode: "id",
        labelKeyOption: "ten",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Ngày sinh",
        key: "ngaysinh",
        type: "date",
        xs: 12,
        md: 6,
        lg: 3,
      },
      {
        name: "Số CCCD/Hộ chiếu",
        key: "socccd",
        type: "text",
        maxLength: 100,
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Ngày cấp",
        key: "ngaycap_cccd",
        type: "date",
        xs: 12,
        md: 4,
        lg: 4,
      },
      {
        name: "Nơi cấp",
        key: "noicap_cccd",
        type: "text",
        maxLength: 100,
        xs: 12,
        md: 4,
        lg: 4,
      },
    ];
    return result;
  }, []);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
      getDistrict(data?.matinh, data?.maquan);
    } else {
      dataDistrictQN &&
        dataDistrictQN.length > 0 &&
        setOptionDistrict(dataDistrictQN);
      setDataState(defaultValue);
    }
  }, [data, dataDistrictQN]);

  async function onSubmitForm(event) {
    event.preventDefault();
    const _data = { ...dataState };
    if (action == "Edit") {
      delete _data["tepdinhkem_chuthe"];
      _data["fileDel"] = fileDel;
      _data["id"] = data?.id;
      _data["rowIndex"] = data?.rowIndex;
    }
    const listFormatDate = ["ngaycap", "ngaycap_cccd", "ngaysinh"];
    listFormatDate?.forEach((field) => {
      _data[field] =
        dataState?.[field] &&
        !errors?.[field] &&
        dayjs(dataState?.[field])?.isValid()
          ? dayjs(dataState?.[field]).format("YYYY-MM-DD")
          : null;
    });
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return;
    }
    // Chuyển đổi tất cả tập tin sang base64
    let jsonPayload = [];
    if (fileFields && fileFields?.length > 0) {
      const promises = [];
      fileFields?.forEach((item) => {
        if (!item?.remove) {
          let json = JsonTool.convertToBase64(item?.file);
          promises.push(json);
        }
      });
      jsonPayload = await Promise.all(promises);
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    let listFileName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listFileName.push(item?.file?.name);
      }
    });
    _data["filename"] = listFileName;
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = jsonPayload;
    onSubmit(_data);
  }

  const handelClear = () => {
    onClose();
  };
  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (open) {
      setErrors({});
      setValue(0);
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    }
  }, [open]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeDataState = (data) => {
    let { name, value } = data;
    setDataState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleErrorDataState = (error) => {
    let { name, value } = error;
    setErrors((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  //change file
  const handleErrorDownload = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };

  return (
    <Dialog
      open={open}
      PaperComponent={PaperComponent}
      onClose={handelClear}
      scroll="paper"
      PaperProps={{
        sx: {
          "@media (min-width: 768px)": {
            minWidth: "48rem",
          },
          height: "100%",
        },
      }}
    >
      {/* Form*/}
      <form
        ref={formRef}
        method="post"
        encType="multipart/form-data"
        style={{
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          height: "100%",
        }}
      >
        {/* Tiêu đề modal - tham số title */}
        <DialogTitle sx={{ m: 0, p: 2, backgroundColor: "#ffffff" }}>
          {title ? title : "Chỉnh sửa Đơn vị"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Box
          sx={{
            width: "100%",
            bgcolor: "background.paper",
            //borderBottom: 1,
            borderColor: "divider",
            padding: "0 1rem 1rem 1rem",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="secondary"
            textColor="primary"
            variant="fullWidth"
            aria-label="basic tabs example"
          >
            <Tab
              icon={<BusinessIcon />}
              label="Thông tin"
              {...JsonTool.a11yProps(0)}
            />
            <Tab
              icon={<ArticleIcon />}
              label="Tệp đính kèm"
              {...JsonTool.a11yProps(1)}
            />
          </Tabs>
        </Box>
        <DialogContent dividers sx={{ overflow: "auto", paddingTop: "0" }}>
          <Box>
            {/* show lỗi từ khi không xác định được từ các field ở form */}
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}

            <CustomTabPanel value={value} index={0}>
              {fieldInfor?.length > 0 && (
                <CustomFieldForm
                  key={"fieldInfor"}
                  listField={fieldInfor}
                  data={dataState}
                  onChange={handleChangeDataState}
                  onError={handleErrorDataState}
                  errorValues={errors}
                  listOptionDic={{
                    matinh: optionProvince,
                    maquan: optionDistrict,
                    maphuong: optionSubDitrict,
                    loaihinh: optionLoaiHinh,
                    trangthai: optionTrangThai,
                    username: dataUser,
                  }}
                />
              )}
              <Accordion
                style={{ marginTop: "1rem", marginBottom: "1rem" }}
                defaultExpanded={true}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                  style={{
                    backgroundColor: "#e3eeff",
                  }}
                >
                  <Typography fontSize={"1rem"} fontWeight={600}>
                    Thông tin người đại diện
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {fieldNguoiDaiDien?.length > 0 && (
                    <CustomFieldForm
                      key={"fieldNguoiDaiDien"}
                      listField={fieldNguoiDaiDien}
                      data={dataState}
                      onChange={handleChangeDataState}
                      onError={handleErrorDataState}
                      errorValues={errors}
                      listOptionDic={{
                        quocgia: optionQuocGia,
                        dantoc: optionDanToc,
                        gioitinh: optionGioiTinh,
                      }}
                    />
                  )}
                </AccordionDetails>
              </Accordion>
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <AddListFile
                dataDefault={data?.tepdinhkem_chuthe}
                fileDel={fileDel}
                fileEditName={fileEditName}
                fileFields={fileFields}
                errors={errors}
                onDelete={handleOnDeleteFileDefault}
                onError={handleErrorFile}
                onFileChange={handleChangeFileList}
                nameFile="chuthe"
                onEditName={handleEditFileNameDefault}
                onErrorDownload={handleErrorDownload}
              />
            </CustomTabPanel>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Lưu
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

const validateRequired = (value) => {
  let result = !!value?.length;
  if (typeof value == "number") {
    result = true;
  }
  return result;
};

const validMail = (value, name) => {
  let result = false;
  if (value && JsonTool.validateEmail(value)) {
    result = true;
  }
  return result;
};
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};

const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(ct, dungluong) {
  let result = {
    ma: !validateRequired(ct.ma)
      ? "Mã/số đăng ký kinh doanh không được trống"
      : "",
    ten: !validateRequired(ct.ten) ? "Tên chủ thể không được trống" : "",
    matinh: !validateRequired(ct.matinh) ? "Chọn Tỉnh thành" : "",
    maphuong: !validateRequired(ct.maphuong) ? "Chọn Phường/Xã" : "",
    maquan: !validateRequired(ct.maquan) ? "Chọn Quận/Quyện" : "",
    email: ct?.email
      ? validMail(ct.email)
        ? "Định dạng Email không đúng"
        : ""
      : "",
    nguoidaidienphapluat_email: ct?.nguoidaidienphapluat_email
      ? validMail(ct.nguoidaidienphapluat_email)
        ? "Định dạng Email không đúng"
        : ""
      : "",
    quocgia: !validateRequired(ct.quocgia) ? "Chọn Quốc gia" : "",
    dantoc: !validateRequired(ct.dantoc) ? "Chọn Dân tộc" : "",
    ngaycap: !validateRequired(ct.ngaycap)
      ? "Ngày cấp trống hoặc sai định dạng"
      : "",
    loaihinh: !validateRequired(ct.loaihinh) ? "Chọn Loại hình tổ chức" : "",
    username: !validateRequired(ct.username) ? "Chọn Tài khoản" : "",
    gioitinh: !validateRequired(ct.gioitinh) ? "Chọn giới tính" : "",
    trangthai: !validateRequired(ct.trangthai) ? "Chọn Trạng thái" : "",
    tentepdinhkem: validateArrayRequired(ct.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      ct.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(ct.tentepdinhkemEdit),
  };
  return result;
}
export default FormChuTheOCOP;
